import { getWeeksInMonth, ZonedDateTime } from '@internationalized/date';
import { useCalendarGrid } from '@react-aria/calendar';
import { CalendarState } from '@react-stately/calendar';

import { fontStyles } from '@/styles/typography';

import { Cell } from './CalendarCell';

const WEEK_DAYS_UI_FORMAT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const WEEK_DAYS_ARIA_LABEL = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

interface CalendarGridProps {
  state: CalendarState;
  now: ZonedDateTime;
}
/**
 * Returns a calendar grid composed of calendar cells in table format.
 */
const Grid = ({ state, now, ...props }: CalendarGridProps) => {
  const { gridProps, headerProps } = useCalendarGrid(props, state);
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, 'en-US');
  const weeks: React.ReactElement[] = [];

  for (let weekIndex = 0; weekIndex < weeksInMonth; weekIndex++) {
    weeks.push(
      <tr key={weekIndex}>
        {state
          .getDatesInWeek(weekIndex)
          .map((date, i) =>
            date ? (
              <Cell key={date.toString()} state={state} date={date} now={now} />
            ) : (
              <td key={i} />
            ),
          )}
      </tr>,
    );
  }

  return (
    <table {...gridProps}>
      <thead
        {...headerProps}
        className={fontStyles({ variant: 'BODY_MD', class: 'text-token-gray-800' })}
      >
        <tr>
          {WEEK_DAYS_UI_FORMAT.map((day, index) => (
            <th key={day} aria-label={WEEK_DAYS_ARIA_LABEL[index]}>
              {day}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{weeks}</tbody>
    </table>
  );
};

export { Grid };
